module.exports = __webpack_public_path__ + "static/langojango-yoruba-language-phrasebook-55b1d4b9b3d49ea20636f2c6dfb7cb71.png";